import React from 'react'
import { useNavigate } from 'react-router-dom';
export default function HeaderCard(props) {
    const navigate = useNavigate();
    return (
        <>
            <ul className='dashboard-tabs-container'>
                {
                    props.data.map((li, liIndex) => {
                        return (
                            <li className='dashboard-tabs largeFont' tabIndex={5} key={liIndex} onClick={() => li.click && !((window.matchMedia('(max-width:768px)').matches)) ? props.clickFunction(liIndex) : navigate("/dashboard/all-VINs")} style={{ cursor: li.click ? "pointer" : null }}>
                                <span className="dashboard-tabs-heading mediumFont">
                                    <span>{li.header}</span>
                                    {/* <span>{liIndex}</span> */}
                                </span>
                                <ul>
                                    {
                                        li.data.map((tabs, tabsIndex) => {
                                            return (
                                                <li className="dashboard-tabs-data" key={tabsIndex}>
                                                    <span className='dashboard-tabs-data-span extraLargeFont'>{tabs.value}</span>
                                                    <span className='secondary-navbar-container-heading regularFont'>{tabs.header}</span>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </li>
                        )
                    })
                }
            </ul>

        </>
    )
}
